import React from 'react';
import { Grid } from '@material-ui/core';
import { Route, Switch } from 'react-router-dom';

import Routes from 'config/routes';

import useIsUpMD from 'hooks/media_query/useIsUpMD';

import LatestRecipes from 'components/recipes/latest_recipes/LatestRecipes';

import MyRecipesPage from 'pages/my_recipes/MyRecipesPage';
import Home from 'pages/home/Home';
import BookmarksPage from 'pages/bookmarks/BookmarksPage';

import UserMenu from './UserMenu';

const Menu = () => {
  const isUpMD = useIsUpMD();

  return (
    <Grid container direction="column">
      <Grid item container justify="center">
        <Grid item container alignItems="flex-start" xs={12} sm={10} md={8}>
          <Grid item xs={12} md={8}>
            <Switch>
              <Route path={Routes.BOOKMARKS}>
                <BookmarksPage></BookmarksPage>
              </Route>

              <Route path={Routes.MY_RECIPES}>
                <MyRecipesPage></MyRecipesPage>
              </Route>

              <Route path={Routes.HOME_PAGE}>
                <Home></Home>
              </Route>
            </Switch>
          </Grid>

          {isUpMD && (
            <Grid item md={4} style={{ paddingLeft: 24 }}>
              <UserMenu></UserMenu>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid item container justify="center" style={{ marginTop: 80 }}>
        <Grid item container alignItems="flex-start" xs={12} sm={10} md={8}>
          <Switch>
            <Route path={Routes.HOME_PAGE} exact>
              <LatestRecipes></LatestRecipes>
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Menu;
